<template>
  <div class="flex-grow">
    <breadcrumb :path="breadcrumbs" />
    <div class="flex flex-col">
      <div class="w-full md:max-w-3xl md:mx-auto px-4">
        <p v-if="feature === null || !feature">
          Feature does not exist.
        </p>
        <div v-else>
          <div class="flex flex-wrap items-center mt-6 mb-4">
            <div class="flex w-full items-center">
              <h1 class="text-nt-blue text-3xl font-bold flex-grow">
                {{ feature.title }}
              </h1>
              <pro-tag
                v-if="feature.pro_feature"
                class="ml-4"
              />
              <enterprise-tag
                v-if="feature.enterprise_feature"
                class="ml-4"
              />
            </div>
          </div>
          <div class="mb-10">
            <div
              class="w-full shadow-xl rounded-lg my-5 max-h-72 flex items-center justify-center overflow-hidden"
            >
              <img
                :src="featureImage"
                alt="Feature cover image"
                class="w-full object-cover"
              >
            </div>
            <div
              class="mt-10"
              v-html="feature.body"
            />

            <div v-if="Object.keys(feature.links ?? {}).length > 0">
              <h4 class="font-semibold mt-5">
                Related Links
              </h4>
              <ul class="list-disc list-inside">
                <li
                  v-for="(value, name) in feature.links"
                  :key="name"
                >
                  <a
                    :href="value"
                    target="_blank"
                  >{{ name }}</a>
                </li>
              </ul>
            </div>

            <div v-if="relatedFeatures?.length > 0">
              <h4 class="font-semibold my-5">
                Related Features
              </h4>
              <div
                class="grid max-w-3xl grid-cols-1 mx-auto text-center sm:text-left sm:grid-cols-2 gap-y-8 gap-x-8 lg:gap-x-20"
              >
                <div
                  v-for="(relatedFeature, index) in relatedFeatures"
                  :key="index"
                  class="relative group"
                >
                  <div
                    class="overflow-hidden rounded-lg aspect-w-16 aspect-h-9 shadow-lg"
                  >
                    <img
                      class="object-cover w-full h-full transition-all duration-300 transform group-hover:scale-110"
                      :src="`/img/pages/features/${relatedFeature.image_url}`"
                      alt=""
                    >
                  </div>
                  <p class="text-xl font-bold text-gray-900 mt-2">
                    {{ relatedFeature.title }}
                  </p>
                  <NuxtLink
                    :to="{
                      params: { slug: relatedFeature.slug },
                      name: 'features-slug',
                    }"
                  >
                    <span
                      class="absolute inset-0"
                      aria-hidden="true"
                    />
                  </NuxtLink>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-blue-500 p-8 rounded-md flex flex-col">
          <p class="text-center text-blue-200 text-sm">
            We are loved by startups, freelancers and many more. 
            Step up your Airtable game with beautiful forms. Get started now 👇
          </p>
          <h2 class="text-white font-semibold text-center my-4">
            Ready to step up your Airtable Game?
          </h2>

          <p class="text-center mt-4 block">
            <v-button
              :to="{ name: 'register' }"
              color="white"
              class="mx-auto"
              font-weight="semibold"
            >
              Create a form for free
            </v-button>
          </p>
        </div>
      </div>
    </div>
    <airtable-forms-footer />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import features from '~/data/features.json'

defineRouteRules({
  swr: 3600,
})

const slug = useRoute().params.slug

const feature = computed(() => {
  return features.find(item => item.slug === slug)
})
const relatedFeatures = computed(() => {
  if (feature.value?.related_features?.length === 0)
    return []
  return features.filter(item =>
    feature.value?.related_features
      ? feature.value.related_features.includes(item.slug)
      : false,
  )
})
const breadcrumbs = computed(() => {
  if (!feature.value)
    return [{ route: { name: 'features' }, label: 'Features' }]

  return [
    { route: { name: 'features' }, label: 'Features' },
    { label: feature.value.title },
  ]
})
const featureImage = computed(() => {
  {
    {
      feature
    }
  }
  return feature.value
    ? `/img/pages/features/${feature.value.image_url}`
    : null
})

useAirtableFormsSeoMeta({
  title: () => {
    if (!feature.value)
      return 'Features'
    return feature.value.title
  },
  ogImage() {
    return featureImage
  },
})
</script>
